import React, { useState } from 'react';
import BackgroundLights from './BackgroundLights';

export const Hero = () => (
    <section id="hero" className="relative min-h-[88vh] flex items-center dark:bg-gray-900 overflow-hidden">
        <div className="absolute inset-0 z-0">
            <img
                src={'/instytut.jpg'}
                alt="Tło edukacyjne"
                className="h-full w-full object-cover scale-100"
            />
            <div className="absolute inset-0 bg-black/80"></div>
            <BackgroundLights />
        </div>
        <div className="relative z-10 container mx-auto px-4 py-24 text-center text-white">
            <span className="inline-flex items-center rounded-full bg-white/10 px-3 py-1 text-xs tracking-wide uppercase">Fundacja absolwentów • Edukacja informatyczna</span>
            <h2 className="mt-6 text-4xl md:text-6xl font-extrabold leading-tight text-white animate-breathing-bloom">
                Wspieramy przyszłość informatyki
                <span className="block">na Uniwersytecie Wrocławskim</span>
            </h2>
            <p className="mt-4 text-lg md:text-xl text-blue-100 max-w-3xl mx-auto">
                Dajemy młodym talentom narzędzia i możliwości: zajęcia, konkursy, stypendia i obozy naukowe
            </p>
            <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center">
                <button onClick={() => window.scrollTo({ top: document.getElementById('cta').offsetTop - 80, behavior: 'smooth' })} className="inline-flex justify-center rounded-full bg-white px-8 py-4 font-bold text-blue-900 shadow-lg shadow-blue-900/20 hover:bg-blue-50 hover:scale-105 transition-all duration-300">
                    Wpłać darowiznę
                </button>
                <button onClick={() => window.scrollTo({ top: document.getElementById('about').offsetTop - 80, behavior: 'smooth' })} className="inline-flex justify-center rounded-full bg-white/10 backdrop-blur-sm px-8 py-4 font-bold text-white ring-1 ring-white/40 hover:bg-white/20 hover:scale-105 transition-all duration-300">
                    Dowiedz się więcej
                </button>
            </div>
            <div className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-3xl mx-auto">
                <div className="rounded-xl bg-white/10 px-6 py-4">
                    <p className="text-3xl font-extrabold">10k+</p>
                    <p className="text-sm text-blue-100">uczestników zajęć i konkursów</p>
                </div>
                <div className="rounded-xl bg-white/10 px-6 py-4">
                    <p className="text-3xl font-extrabold">200+</p>
                    <p className="text-sm text-blue-100">zorganizowanych wydarzeń</p>
                </div>
                <div className="rounded-xl bg-white/10 px-6 py-4">
                    <p className="text-3xl font-extrabold">15 lat</p>
                    <p className="text-sm text-blue-100">wsparcia środowiska IT</p>
                </div>
            </div>
        </div>
    </section>
);

export const About = () => (
    <section id="about" className="py-20 bg-white dark:bg-gray-900">
        <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
                <div className="order-2 md:order-1">
                    <h2 className="text-3xl md:text-4xl font-extrabold mb-6 text-gray-900 dark:text-white">Krótko o nas</h2>
                    <div className="space-y-4 text-gray-700 dark:text-gray-200 leading-relaxed">
                        <p className="fade-in">Fundacja powstała z inicjatywy absolwentów Instytutu Informatyki UWr i wspomaga działania edukacyjne prowadzone przez Instytut na poziomie szkolnym i studenckim.</p>
                        <p className="fade-in2">Nikt z nas nie urodził się programistą. Komputer był dla nas kiedyś tajemniczą skrzynką, później – maszynką do gier, zakupów, poznawania ludzi. Pamiętamy nasze pierwsze „Hello, World!”, i dalszą drogę: lata spędzone na nauce, treningu, wyzwania pierwszych zawodów, pierwszy sprzedany kod, pierwszy projekt, zespół, firmę; pierwszych użytkowników i pierwsze duże pieniądze.</p>
                        <p className="fade-in3">Pamiętamy, że gdzieś na tej drodze pojawił się student, doktorant, a czasem nawet siwowłosy profesor UWr. Wiele zawdzięczamy ich pracy. Chcemy wspomagać działania, w których sami kiedyś uczestniczyliśmy i które pomogły nam odnieść sukces.</p>
                        <p className="fade-in4">Fundacja zapewnia dodatkowe środki na organizację rozmaitych zajęć informatycznych: 
                            
                            <ul className="mt-4 space-y-2 text-gray-700 dark:text-gray-300 list-disc">
                            <li><strong>fakultetów w liceach i szkołach podstawowych</strong> – są dla większości uczniów pierwszym kontaktem z informatyką. Fundacja pomaga w wynagradzaniu prowadzących, którzy prowadzą uczniów od pierwszych kroków do medali Olimpiady Informatycznej.</li>
                            <li><strong>sparingów i zawodów</strong> – zapewniają niezbędny trening uczniom, którzy walczą o tytuły najlepszych programistów i programistek w kraju. Fundacja dokłada się do kosztów przygotowania zadań i nagród dla uczestników.</li>
                            <li><strong>obozów naukowych</strong> – gromadzą uczniów z różnych szkół i są czasem intensywnej pracy: początkujący wspólnie zdobywają podstawy informatycznego fachu, zaawansowani uczą się od siebie nawzajem i przygotowują do startu w zawodach. Fundacja udziela stypendiów na pokrycie kosztów dla potrzebujących uczestników oraz wspiera finansowo wynagrodzenia kadry.</li>
                            </ul>
                            </p>
                    </div>
                </div>
                <div className="order-1 md:order-2">
                    <div className="relative overflow-hidden rounded-2xl shadow-xl">
                        <img src="/obozy.jpg" alt="Wspólnota i nauka" className="w-full h-80 object-cover" />
                        <div className="absolute inset-0 bg-gradient-to-t from-blue-900/30 to-transparent"></div>
                    </div>
                </div>
            </div>
        </div>
    </section>
);

export const Programs = () => (
    <section id="programs" className="py-20 bg-gray-50 dark:bg-gray-950">
        <div className="container mx-auto px-4">
            <h2 className="text-3xl md:text-4xl font-extrabold mb-12 text-center text-gray-900 dark:text-white">Cele i realizacja</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                <div className="group relative overflow-hidden rounded-2xl bg-white dark:bg-gray-900 p-8 shadow-lg ring-1 ring-gray-100 dark:ring-white/5 transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl hover:shadow-blue-500/10 dark:hover:shadow-blue-900/20 hover:ring-blue-500/20">
                    <div className="absolute -right-10 -top-10 h-32 w-32 rounded-full bg-blue-100 blur-2xl group-hover:bg-blue-200 transition-colors"></div>
                    <div className="flex items-center justify-between">
                        <h3 className="text-xl font-bold text-gray-900 dark:text-white">Cele fundacji</h3>
                        <span className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-blue-600 text-white">1</span>
                    </div>
                    <ul className="mt-4 space-y-2 text-gray-700 dark:text-gray-300 list-none">
                        <li>Rozpowszechnianie wiedzy i kultury informatycznej</li>
                        <li>Edukacja i badania naukowe</li>
                        <li>Kształcenie kadr informatycznych</li>
                    </ul>
                </div>
                <div className="group relative overflow-hidden rounded-2xl bg-white dark:bg-gray-900 p-8 shadow-lg ring-1 ring-gray-100 dark:ring-white/5 transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl hover:shadow-indigo-500/10 dark:hover:shadow-indigo-900/20 hover:ring-indigo-500/20">
                    <div className="absolute -right-10 -top-10 h-32 w-32 rounded-full bg-indigo-100 blur-2xl group-hover:bg-indigo-200 transition-colors"></div>
                    <div className="flex items-center justify-between">
                        <h3 className="text-xl font-bold text-gray-900 dark:text-white">Realizacja celów</h3>
                        <span className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-indigo-600 text-white">2</span>
                    </div>
                    <ul className="mt-4 space-y-2 text-gray-700 dark:text-gray-300 list-none">
                        <li>Zajęcia, kursy i obozy</li>
                        <li>Konkursy i olimpiady</li>
                        <li>Projekty edukacyjne i naukowe</li>
                        <li>Szkolenia i doradztwo</li>
                        <li>Wsparcie organizacyjne i finansowe</li>
                    </ul>
                </div>
                <div className="group relative overflow-hidden rounded-2xl bg-white dark:bg-gray-900 p-8 shadow-lg ring-1 ring-gray-100 dark:ring-white/5 transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl hover:shadow-violet-500/10 dark:hover:shadow-violet-900/20 hover:ring-violet-500/20">
                    <div className="absolute -right-10 -top-10 h-32 w-32 rounded-full bg-violet-100 blur-2xl group-hover:bg-violet-200 transition-colors"></div>
                    <div className="flex items-center justify-between">
                        <h3 className="text-xl font-bold text-gray-900 dark:text-white">Formy wsparcia</h3>
                        <span className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-violet-600 text-white">3</span>
                    </div>
                    <ul className="mt-4 space-y-2 text-gray-700 dark:text-gray-300 list-none">
                        <li>Stypendia i granty</li>
                        <li>Zakup pomocy naukowych</li>
                        <li>Dopłaty do obozów naukowych</li>
                        <li>Współpraca z nauką i biznesem</li>
                    </ul>
                </div>
            </div>
        </div>
    </section>
);

export const CTA = () => {
    const [copied, setCopied] = useState(false);

    const handleCopy = async (text) => {
        try {
            await navigator.clipboard.writeText(text);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (_) { }
    };

    return (
        <section id="cta" className="py-20 bg-gradient-to-br from-blue-800 to-indigo-800 text-white dark:from-blue-900 dark:to-indigo-900">
            <div className="container mx-auto px-4">
                <div className="mx-auto max-w-4xl text-center">
                    <h2 className="text-3xl md:text-4xl font-extrabold mb-4 fade-in">Wesprzyj Fundację</h2>
                    <p className="text-lg md:text-xl mb-10 fade-in text-blue-100 text-left">
                            Wesprzyj naszą misję – Twoja pomoc ma znaczenie!<br />
                            Każda, nawet najmniejsza darowizna, pozwala nam realizować cele statutowe i realnie zmieniać życie tych, którym pomagamy.<br />
                            <br />
                            Jeśli chcesz zaangażować się głębiej w działalność Fundacji – jako wolontariusz, partner czy ambasador naszej misji – serdecznie zapraszamy do kontaktu!<br />
                            <br />
                            <strong>100% otrzymanych środków przeznaczamy wyłącznie na działalność statutową.</strong><br />
                            <br />
                            Wpłaty można przekazywać na następujące konta:
                        </p>
                </div>
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
                    <div className="lg:col-span-2 rounded-2xl bg-white/10 p-6 ring-1 ring-white/20 relative">
                        <div className={`absolute top-3 right-3 rounded-md bg-white text-blue-900 text-xs px-2 py-1 shadow transition-opacity duration-700 ${copied ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}>dane skopiowane</div>
                        <p className="text-sm uppercase tracking-wide mb-2 text-blue-200">Dane do przelewu</p>
                        <ul className="space-y-2 text-sm md:text-base">
                            <li>
                                <div className="flex items-center justify-between gap-3">
                                    <span><span className="text-blue-200">PLN:</span> 88 1240 1473 1111 0011 2847 0067</span>
                                    <button onClick={() => handleCopy('88 1240 1473 1111 0011 2847 0067')} className="inline-flex items-center justify-center h-7 w-7 rounded hover:bg-white/10 focus:outline-none" title="Kopiuj PLN" aria-label="Kopiuj PLN">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="h-4 w-4">
                                            <rect x="9" y="9" width="10" height="10" rx="2"></rect>
                                            <rect x="5" y="5" width="10" height="10" rx="2"></rect>
                                        </svg>
                                    </button>
                                </div>
                            </li>
                            <li>
                                <div className="flex items-center justify-between gap-3">
                                    <span><span className="text-blue-200">CHF:</span> 97 1240 1473 1797 0011 2847 1107</span>
                                    <button onClick={() => handleCopy('97 1240 1473 1797 0011 2847 1107')} className="inline-flex items-center justify-center h-7 w-7 rounded hover:bg-white/10 focus:outline-none" title="Kopiuj CHF" aria-label="Kopiuj CHF">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="h-4 w-4">
                                            <rect x="9" y="9" width="10" height="10" rx="2"></rect>
                                            <rect x="5" y="5" width="10" height="10" rx="2"></rect>
                                        </svg>
                                    </button>
                                </div>
                            </li>
                            <li>
                                <div className="flex items-center justify-between gap-3">
                                    <span><span className="text-blue-200">EUR:</span> 65 1240 1473 1978 0011 2847 0878</span>
                                    <button onClick={() => handleCopy('65 1240 1473 1978 0011 2847 0878')} className="inline-flex items-center justify-center h-7 w-7 rounded hover:bg-white/10 focus:outline-none" title="Kopiuj EUR" aria-label="Kopiuj EUR">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="h-4 w-4">
                                            <rect x="9" y="9" width="10" height="10" rx="2"></rect>
                                            <rect x="5" y="5" width="10" height="10" rx="2"></rect>
                                        </svg>
                                    </button>
                                </div>
                            </li>
                            <li>
                                <div className="flex items-center justify-between gap-3">
                                    <span><span className="text-blue-200">USD:</span> 94 1240 1473 1787 0011 2847 0982</span>
                                    <button onClick={() => handleCopy('94 1240 1473 1787 0011 2847 0982')} className="inline-flex items-center justify-center h-7 w-7 rounded hover:bg-white/10 focus:outline-none" title="Kopiuj USD" aria-label="Kopiuj USD">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="h-4 w-4">
                                            <rect x="9" y="9" width="10" height="10" rx="2"></rect>
                                            <rect x="5" y="5" width="10" height="10" rx="2"></rect>
                                        </svg>
                                    </button>
                                </div>
                            </li>
                            <li>
                                <div className="flex items-center justify-between gap-3">
                                    <span><span className="text-blue-200">GBP:</span> 98 1240 1473 1789 0011 2847 1295</span>
                                    <button onClick={() => handleCopy('98 1240 1473 1789 0011 2847 1295')} className="inline-flex items-center justify-center h-7 w-7 rounded hover:bg-white/10 focus:outline-none" title="Kopiuj GBP" aria-label="Kopiuj GBP">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="h-4 w-4">
                                            <rect x="9" y="9" width="10" height="10" rx="2"></rect>
                                            <rect x="5" y="5" width="10" height="10" rx="2"></rect>
                                        </svg>
                                    </button>
                                </div>
                            </li>
                        </ul>
                        <div className="mt-4 pt-4 border-t border-white/20">
                            <p className="text-sm uppercase tracking-wide mb-2 text-blue-200">Tytuł przelewu</p>
                            <div className="flex items-center justify-between gap-3 text-sm md:text-base">
                                <span>Darowizna na cele statutowe – Fundacja II UWr</span>
                                <button onClick={() => handleCopy('Darowizna na cele statutowe – Fundacja II UWr')} className="inline-flex items-center justify-center h-7 w-7 rounded hover:bg-white/10 focus:outline-none" title="Kopiuj tytuł" aria-label="Kopiuj tytuł">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="h-4 w-4">
                                        <rect x="9" y="9" width="10" height="10" rx="2"></rect>
                                        <rect x="5" y="5" width="10" height="10" rx="2"></rect>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="rounded-2xl bg-white p-6 text-blue-900 shadow-xl">
                        <h3 className="text-xl font-bold">Darowizna online</h3>
                        <p className="mt-2 text-sm text-blue-800/80">Wkrótce uruchomimy szybkie płatności. Na razie prosimy o przelew tradycyjny.</p>
                        <button onClick={() => alert('Dziękujemy za wsparcie!')} className="mt-6 w-full inline-flex justify-center rounded-full bg-blue-700 px-6 py-3 font-semibold text-white shadow-sm hover:bg-blue-800">Wpłać darowiznę</button>
                    </div>
                </div>
            </div>
        </section>
    );
};

export const Contact = () => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [emailError, setEmailError] = useState('');

    const handleSubmit = () => {
        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            setEmailError('Wprowadź prawidłowy adres email');
            return;
        } else {
            setEmailError('');
        }
        fetch('https://your-worker-url.workers.dev', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                name,
                email,
                message,
            }),
        })
        .then(response => {
            if (response.ok) {
                alert('Wiadomość została wysłana!');
                setName('');
                setEmail('');
                setMessage('');
            } else {
                alert('Błąd podczas wysyłania wiadomości.');
            }
        })
        .catch(() => {
            alert('Błąd podczas wysyłania wiadomości.');
        });
    };

    return (
        <section id="contact" className="py-20 bg-white dark:bg-gray-900">
            <div className="container mx-auto px-4">
                <h2 className="text-3xl md:text-4xl font-extrabold mb-10 text-center text-gray-900 dark:text-white">Kontakt</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-stretch">
                    <div className="fade-in">
                        <div className="rounded-2xl bg-gray-50 dark:bg-gray-800 p-6 border border-gray-100 dark:border-gray-800 shadow-sm h-full text-gray-700 dark:text-gray-200">
                            <h3 className="text-xl font-bold mb-4 text-gray-900 dark:text-white">Dane adresowe</h3>
                            <p>Fundacja Absolwentów Instytutu Informatyki Uniwersytetu Wrocławskiego</p>
                            <div className="flex items-center">
                                <p>ul. Joliot-Curie 15</p>
                                <a href="https://www.google.com/maps?q=Instytut Informatyki Uniwersytetu Wrocławskiego+Wrocław" target="_blank" rel="noopener noreferrer" className="ml-2 text-blue-700 dark:text-blue-300 hover:text-blue-800 dark:hover:text-blue-400" title="Otwórz w Google Maps">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="h-5 w-5">
                                        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                                        <circle cx="12" cy="10" r="3"></circle>
                                    </svg>
                                </a>
                            </div>
                            <p>50-523 Wrocław</p>
                            <p className="mt-2"><a className="text-blue-700 dark:text-blue-300 hover:underline" href="mailto:fundacjaabsolwentowiiuwr@cs.uni.wroc.pl">fundacjaabsolwentowiiuwr@cs.uni.wroc.pl</a></p>
                            <h3 className="text-xl font-bold mt-6 mb-2 text-gray-900 dark:text-white">Dane rejestrowe</h3>
                            <p>KRS 0001044963</p>
                            <p>NIP 8992964804</p>
                            <p>REGON 525742650</p>
                        </div>
                    </div>
                    <div className="fade-in">
                        <div className="rounded-2xl bg-gray-50 dark:bg-gray-800 p-6 border border-gray-100 dark:border-gray-800 shadow-sm h-full">
                            <h3 className="text-xl font-bold mb-4 text-gray-900 dark:text-white">Wyślij wiadomość</h3>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                <input type="text" placeholder="Imię" value={name} onChange={(e) => setName(e.target.value)} className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600 dark:border-gray-700 dark:bg-gray-900 dark:text-white" />
                                <div>
                                    <input type="email" placeholder="Email" value={email} onChange={(e) => { setEmail(e.target.value); setEmailError(''); }} className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600 dark:border-gray-700 dark:bg-gray-900 dark:text-white" />
                                    {emailError && <p className="text-red-500 text-sm mt-1">{emailError}</p>}
                                </div>
                            </div>
                            <textarea placeholder="Wiadomość" value={message} onChange={(e) => setMessage(e.target.value)} className="mt-4 w-full p-3 border rounded-lg h-32 focus:outline-none focus:ring-2 focus:ring-blue-600 dark:border-gray-700 dark:bg-gray-900 dark:text-white"></textarea>
                            <button onClick={handleSubmit} className="mt-4 inline-flex items-center rounded-full bg-blue-700 px-6 py-3 font-semibold text-white shadow-sm hover:bg-blue-800">Wyślij</button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

const Home = () => {
    return (
        <>
            <Hero />
            <About />
            <Programs />
            <CTA />
            <Contact />
        </>
    );
};

export default Home;
